package dev.lingvo.shared.ops

import kotlinx.serialization.Serializable

/** Who the console thinks you are, and how many people can see it. */
@Serializable
data class OpsIdentityDto(
    val email: String,
    /** When this operator's session began, ISO-8601. Null if it has been revoked mid-call. */
    val since: String? = null,
    val allowlistSize: Int,
)
